import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "./case";
import { Address } from "../../common/_types/address";

/**
 * Papel del implicado dentro del expediente. Los tres valores son excluyentes.
 * Espejo de AffectedPartyType en GUAI.Domain/Attendance/Models/Affected.cs. Los valores son cadenas,
 * no los enteros de la columna: la API serializa los enums por el nombre del miembro
 * (JsonStringEnumConverter), como el resto de enums espejo del frontend.
 */
export enum AffectedPartyType {
    Affected = "Affected",
    ProblemCause = "ProblemCause",
    Client = "Client"
}

/** Literales del tipo de implicado, para el desplegable y para pintarlo en los listados. */
export const AFFECTED_PARTY_TYPE_LABELS: { id: AffectedPartyType, label: string }[] = [
    { id: AffectedPartyType.Affected, label: "Afectado" },
    { id: AffectedPartyType.ProblemCause, label: "Causante" },
    { id: AffectedPartyType.Client, label: "Cliente" }
];

export function affectedPartyTypeLabel(partyType: AffectedPartyType): string {
    return AFFECTED_PARTY_TYPE_LABELS.find(m => m.id == partyType)?.label ?? "";
}

export class Affected extends Resource {
    public override type = 'affecteds';

    @prop()
    @required()
    public name!: string;

    @prop()
    public legalName!: string;

    @prop()
    public typeOfBusiness: number = 1;
    @prop()
    public email!: string;
    @prop()
    public phone1!: string;
    @prop()
    public phone2!: string;
    @prop()
    public phone3!: string;
    @prop()
    public active: boolean = true;
    @prop()
    public vatNumber!: string;


    @prop()
    public addressId!: string;

    @propObject(Address)
    public address: Address = new Address();

    @prop()
    @required()
    public caseId!: string;


    public case: Case = new Case();

    @prop()
    public partyType: AffectedPartyType = AffectedPartyType.Affected;
}